import { render, staticRenderFns } from "./Cardschool.vue?vue&type=template&id=81175238&scoped=true"
import script from "./Cardschool.vue?vue&type=script&lang=js"
export * from "./Cardschool.vue?vue&type=script&lang=js"
import style0 from "./Cardschool.vue?vue&type=style&index=0&id=81175238&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81175238",
  null
  
)

export default component.exports